import { trackPage } from 'lib/ui-analytics';
import { TRACKING_COMPARE, PROD_CATEGORY } from 'contexts/AnalyticsContext/Constants';

export const utagComparePageLoad = (cruises, locale) => {

    const event = {
        cardPosition: cruises.map((_cruise, index) => index + 1),
        country: locale.country,
        currency: locale.currency,
        language: locale.language,
        siteSection: TRACKING_COMPARE.COMPARE_PAGE,
        pageName: TRACKING_COMPARE.COMPARE_PAGE,
        departureDate: cruises.map(cruise => cruise?.lowestPriceSailing?.startDate),
        prodCategory: cruises.map(() => PROD_CATEGORY.booking.toLowerCase()),
        prodCost: cruises.map( cruise => Math.round(cruise?.lowestPriceSailing?.lowestStateroomClassPrice?.price?.value)),
        prodSku: cruises.map( cruise => cruise?.masterSailing?.itinerary?.code),
        prodQuantity: cruises.map(() => 1),
        groupId: cruises.map( cruise => cruise?.lowestPriceSailing?.id),
        productEvent: cruises.map(() => TRACKING_COMPARE.COMPARE_START)
    }
    trackPage(event);
}
